import { render } from "./FooterNavbar.vue?vue&type=template&id=b94b58be"
import script from "./FooterNavbar.vue?vue&type=script&lang=js"
export * from "./FooterNavbar.vue?vue&type=script&lang=js"

import "./FooterNavbar.vue?vue&type=style&index=0&id=b94b58be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__